import { inject, injectable, interfaces } from 'inversify';
import { IUserStore } from '../../../__legacy__/modules/user/user.store';

export interface ICursorControlBl {
  toggleCursorGuides(): void;
  toggleImprovedVisibilityCursor(): void;
}

export namespace ICursorControlBl {
  export const $: interfaces.ServiceIdentifier<ICursorControlBl> = Symbol('CURSOR_CONTROL_BL_TYPE');
}

@injectable()
export class CursorControlBl implements ICursorControlBl {
  constructor(@inject(IUserStore.$) private readonly userStore: IUserStore) {}

  toggleCursorGuides(): void {
    this.userStore.areCursorGuidesEnabled = !this.userStore.areCursorGuidesEnabled;
  }

  toggleImprovedVisibilityCursor(): void {
    this.userStore.isImprovedVisibilityCursorEnabled = !this.userStore.isImprovedVisibilityCursorEnabled;
  }
}
